import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'calendars/carcalendar';
const wizardName = 'Calendar';
const wizardAction = 'calendarManagement';
const wizardObject = 'Calendar';

const CarCalendar = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(false);

    // DATA PROVIDER
    const {
        item,
        loadOne,
        errorMessage,
        errors,
        saving,
        doAction,
        reset
    } = useDataProvider(dataProviderName, false);

    const modelName = existingModules.modelName;

    let detailConfig = {
        "tabs": [
            {
                "name": "booking",
                "fieldsets": [
                    {
                        "name": "booking",
                        "fields": {
                            "calendar": {
                                "type": "calendarBooking",
                                "calendar_id": item?.data?._id ?? null,
                                "currentDriver": [{employment:params.driver}] ?? null,
                                "className": "col-12",
                                "label": item?.data?._id ?? null,
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        reset();
        if (params.car?.calendar?._id) {
            loadOne(params.car?.calendar?._id).then(() => {
                //debugger;
                setDrawable(true);
            });
        }
    }, []);

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const car = params.car;
    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                values={{
                    "car_id": car?._id,
                    "legal_entity_id": car?.legalEntity?._id,
                    "_id": item?.data?._id
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Book a slot in the {{wizardObject}} of vehicle with plate {{carIdentifier}}', { wizardObject: wizardObject, carIdentifier: (car?.plate ? car?.plate : car?.setup?.make + " " + car?.setup?.model) })}
                    />
                }
                {...params}
            />
    )
}

export default CarCalendar;


